import { createSlice } from '@reduxjs/toolkit';

const initialDonationState = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: null,
    donationForEdit: undefined,
    loadingProgress: false,
    lastError: null,
};

export const callTypes = {
    list: 'list',
    action: 'action',
};

export const donationSlice = createSlice({
    name: 'donation',
    initialState: initialDonationState,
    reducers: {
        catchError: (state, action) => {
            state.error = action.payload.error;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
                state.loadingProgress = action.payload.loadingProgress
            } else {
                state.actionsLoading = false;
                state.loadingProgress = action.payload.loadingProgress
            }
        },
        startCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
                state.loadingProgress = action.payload.loadingProgress
            }
        },

        // getDonationById
        donationFetched: (state, action) => {
            state.actionsLoading = false;
            state.error = null;
            state.donationForEdit = action.payload.donationForEdit;
            state.reconcileData = action.payload.reconcileData;
        },

        // findDonations
        donationsFetched: (state, action) => {
            // const { total_items, items, donation_item_array } = action.payload;
            const { total_items, items } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entities = items;
            state.totalCount = total_items;
            // state.donation_item_array = donation_item_array
        },
        // donation payments
        donationPaymentsFetched: (state, action) => {
            // const { total_items, items, donation_item_array } = action.payload;
            const { total_items, items } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entities = items;
            state.totalCount = total_items;
            // state.donation_item_array = donation_item_array
        },

        // Set to default state actionLoading & error
        donationReload: (state, action) => {
            state.actionsLoading = false;
            state.listLoading = false;
            state.error = null;
            state.reconcileData = action.payload.reconcileData;
        },

    },
});

